import React from 'react'
import { Link } from 'react-router-dom'

const AllServices = () => {
  return (
    <div className='bg-slate-100 h-full'>
      <br />
      <h2 className=" ml-5 mr-5 text-2xl font-semibold text-black text-center bg-[#b0c22a] p-6 rounded-lg shadow-lg transition-transform duration-300">
        All Services
      </h2>
      <div className="p-2 sm:p-6 lg:p-8">
        {/* <h1 className='font-bold text-2xl sm:text-3xl text-center text-blue-800 mb-4'>-  -</h1> */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
          <Link
            to="/shop_act_new"
            className="bg-white text-center border p-2  shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(255, 105, 180, 0.5)' }} // Pink shadow initially (matching the pink accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(255, 105, 180, 0.5)')} // Revert to pink after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">DA Calculation
            </h5>
          </Link>
          <Link
            to="/pan_service"
            className="bg-white text-center border p-2  shadow-lg hover:shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 128, 0, 0.5)' }} // Green shadow initially
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 128, 0, 0.5)')} // Revert to green after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Govt Books & GR</h5>
          </Link>
          <Link
            to="/driving_Lic"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 0, 255, 0.5)' }} // Blue shadow initially (matching the blue accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 0, 255, 0.5)')} // Revert to blue after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Income Tax Calculation</h5>
          </Link>
          <Link
            to="/food_lic"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(255, 165, 0, 0.5)' }} // Orange shadow initially (matching the orange accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(255, 165, 0, 0.5)')} // Revert to orange after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Pension Proposal (Final)</h5>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
          <Link
            to="/income_certificate"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 0, 255, 0.5)' }} // Blue shadow initially (matching the blue accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 0, 255, 0.5)')} // Revert to blue after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">GPF Proposal (Final)</h5>
          </Link>
          <Link
            to="/company_registration"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(255, 105, 180, 0.5)' }} // Pink shadow initially (matching the pink accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(255, 105, 180, 0.5)')} // Revert to pink after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">GIS Proposal (Final)
            </h5>
          </Link>
          <Link
            to="/gazzette"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(255, 165, 0, 0.5)' }} // Orange shadow initially (matching the orange accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(255, 165, 0, 0.5)')} // Revert to orange after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Leave Encashment Proposal </h5>
          </Link>
          <Link
            to="/gst_registration"
            className="bg-white text-center border p-2 shadow-lg hover:shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 128, 0, 0.5)' }} // Green shadow initially
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 128, 0, 0.5)')} // Revert to green after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Inter District Transfer</h5>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-5">
          <Link
            to="/tredmark"
            className="bg-white text-center border p-2 shadow-lg hover:shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 128, 0, 0.5)' }} // Green shadow initially
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 128, 0, 0.5)')} // Revert to green after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">GPF Proposal</h5>
          </Link>
          <Link
            to="/digital_signature"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(255, 165, 0, 0.5)' }} // Orange shadow initially (matching the orange accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(255, 165, 0, 0.5)')} // Revert to orange after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Pay Fixation</h5>
          </Link>
          <Link
            to="/legal_consultancy"
            className="bg-white text-center border p-2 shadow-lg hover:-translate-y-2 transition-transform duration-300"
            style={{ boxShadow: '0 2px 3px rgba(0, 0, 255, 0.5)' }} // Blue shadow initially (matching the blue accent color)
            onMouseEnter={(e) => (e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.5)')} // Black shadow on hover
            onMouseLeave={(e) => (e.currentTarget.style.boxShadow = '0 2px 3px rgba(0, 0, 255, 0.5)')} // Revert to blue after hover
          >
            <h5 className="text-xl font-semibold mt-3 mb-3">Website Design</h5>
          </Link>
          
        </div>


      </div>

    </div>
  )
}

export default AllServices
